<button (click)="backToList()" class="btn btn-round btn-primary btn-mini mb-3">
  < {{ 'Rules.backToList' | translate }}
</button>

<section [formGroup]="formGroup">
  <div class="row">
    <div class="col-12 col-lg-10">
      <h4>{{ (rule.id ? 'EditRule.title' : 'AddRule.title') | translate: { priority: priority + 1 } }}</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-12">
      <section class="form-group">
        <label for="path" class="h5">
          {{ 'Paths' | translate }}
          <a [href]="'ExternalHelp.regex' | translate" class="ogo-link" target="_blank">
            ({{ 'RegexpGuide' | translate }}<i class="icofont icofont-external-link ml-1"></i>)
          </a>
        </label>
        <p>{{ 'Rule.paths.description' | translate }}</p>

        <ng-select
          [items]="[]"
          [formControl]="paths"
          (paste)="onPastePaths($event)"
          [multiple]="true"
          [addTag]="addPath"
          (add)="onAddPath($event)"
          [clearable]="true"
          [searchable]="true"
          [openOnEnter]="false"
          [isOpen]="false"
          [closeOnSelect]="true"
          [editableSearchTerm]="true"
          [selectOnTab]="true"
          [placeholder]="'AccessControlRules.PlaceholderPath' | translate"
          #pathsExceptionsNgSelect
          (blur)="pathsExceptionsNgSelect.selectTag()"
        />
      </section>
      <hr />
    </div>
    <div class="col-xl-12">
      <h5>{{ 'Rule.actions.label' | translate }}</h5>
      <label for="defaultPolicy">{{ 'Rule.ipFilter' | translate }}</label>
      <div class="radio-buttons">
        @for (p of Policies; track $index) {
          <span
            ><input [formControl]="defaultPolicy" [id]="'defaultPolicy-' + p" [value]="p" type="radio" /><label
              [for]="'defaultPolicy-' + p"
              >{{ 'Rule.defaultPolicy.' + p | translate }}</label
            ></span
          >
        }
      </div>
    </div>
    <div class="col-xl-12">
      <section class="form-group ng-select-no-dropdown">
        <label for="ipExceptions">{{ 'Rule.ipExceptions.label.' + defaultPolicy.getRawValue() | translate }}</label>
        <ng-select
          [items]="[]"
          [formControl]="ipExceptions"
          (paste)="onPasteIps($event)"
          [multiple]="true"
          [addTag]="addIp"
          (add)="onAddIp($event)"
          [clearable]="true"
          [searchable]="true"
          [openOnEnter]="false"
          [isOpen]="false"
          [closeOnSelect]="true"
          [editableSearchTerm]="true"
          [selectOnTab]="true"
          [placeholder]="'Rule.ipExceptions.placeholder' | translate"
          #ipExceptionsNgSelect
          (blur)="ipExceptionsNgSelect.selectTag()"
        />
      </section>
    </div>

    <div class="col-xl-12">
      <div class="row">
        <label for="action" class="col col-form-label">{{ 'Rule.action.label' | translate }}</label>
        <app-switch class="col-auto" formControlName="brainAnalysisEnabled" />
      </div>
    </div>

    @if (clusterConfig.supportsChallenge) {
      <div class="col-xl-12 mt-1">
        <div class="row">
          <label for="action" class="col col-form-label"
            >{{ 'Challenge.label' | translate }}
            <label-beta />
            <app-help hrefKey="ExternalHelp.challenge" tooltipPlacement="bottom" class="ml-1" />
          </label>
          <div class="col-auto">
            <select class="form-control form-control-sm" style="width: 179px" formControlName="challenge">
              <option *ngFor="let mode of ChallengeTypes" [value]="mode">
                {{ 'Challenge.Type.' + mode | translate }}
              </option>
            </select>
          </div>
        </div>
      </div>
    }

    @if (clusterConfig.supportsCache) {
      <div class="col-xl-12 mt-1">
        <div class="row">
          <label for="cache" class="col col-form-label">{{ 'Rule.cache.label' | translate }}</label>
          <app-switch class="col-auto" formControlName="cache" [disabled]="!siteCacheEnabled" />
        </div>
      </div>
    }
    @if (canCustomErrorProfile) {
      <div *featureFlag="'customPagesProfile'" class="col-xl-12 mt-1">
        <div class="row">
          <div class="col col-form-label">
            <label>{{ 'ErrorHandler.selected' | translate }}</label
            >&nbsp;
          </div>
          <div class="col-auto">
            <ng-select
              [addTag]="false"
              [items]="customPagesProfileModels"
              [placeholder]="'NoOption' | translate"
              appendTo="body"
              bindLabel="name"
              formControlName="customPagesProfile"
              name="customPagesProfile"
              style="width: 179px"
            />
          </div>
        </div>
      </div>
    }

    <div class="col-12 form-group">
      <hr />
      <label for="comment" class="h5">{{ 'Comments' | translate }}</label>
      <textarea class="w-100 form-control" formControlName="comment" id="comment" name="comment" rows="6"></textarea>
    </div>
  </div>

  <section class="d-flex justify-content-end">
    <button (click)="emitCancel()" class="btn btn-sm btn-danger mr-2">
      {{ 'Annuler' | translate }}
    </button>

    <button [disabled]="!formGroup.valid" (click)="emitValidate()" class="btn btn-sm btn-primary">
      {{ (rule.id ? 'EditRule.validate' : 'AddRule.validate') | translate }}
    </button>
  </section>
</section>
